module.exports = __webpack_public_path__ + "img/nav-design-fancy@2x.a8a67ec.jpg";